import {
  GET_ORDERS,
  GET_ORDER,
  OFFER_DETAILS,
  ORDER_LIST,
  SELECT_OFFER_ALL_MY_OFFERS,
  SELECT_ALL_OFFERS,
  REFRESH_ITEM,
  GET_ORDER_ITEMS,
  MANAGEMENT_INVENTORIES_PAGE_LOADED,
  CHANGE_ALL_MY_OFFERS_DETAILS,
  MANUEL_STOCK_PAGE_DETAILS,
  GET_ORDER_BLENDING,
} from "../constants/actionTypes";

const defaultState = {
  orderList: undefined,
  selected_all_my_offer: undefined,
  selected_waiting_my_confirmation: undefined,
  customPrice: false,
  selected_all_offers: undefined,
  offerPrice: 0,
  offerQuantity: 0,
  order: undefined,
  orderItems: undefined,
  blending: undefined,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ORDERS:
      return {
        ...state,
        orderList: action.payload,
      };
    case GET_ORDER_BLENDING:
      return {
        ...state,
        blending: action.payload,
      };
    case GET_ORDER:
      return {
        ...state,
        order: action.payload,
      };
    case OFFER_DETAILS:
      return {
        ...state,
        [action.key]: action.value,
      };
    case ORDER_LIST:
      return {
        ...state,
        orderList: action.payload,
      };

    case SELECT_OFFER_ALL_MY_OFFERS:
      return {
        ...state,
        selected_all_my_offer: action.offer,
      };
    case SELECT_ALL_OFFERS:
      return {
        ...state,
        selected_all_offers: action.offer,
      };
    case GET_ORDER_ITEMS:
      return {
        ...state,
        orderItems: action.payload,
      };
    case CHANGE_ALL_MY_OFFERS_DETAILS:
      return {
        ...state,
        [action.key]: action.value,
      };
    case REFRESH_ITEM:
      return {
        ...state,
        orderList: {
          ...state.orderList,
          Items: state.orderList.Items.map((item) => {
            return item.Id === action.payload[0].Id ? action.payload[0] : item;
          }),
        },
      };
    case MANAGEMENT_INVENTORIES_PAGE_LOADED:
      return {
        ...state,
        inventories: action.payload,
      };
    case MANUEL_STOCK_PAGE_DETAILS:
      return {
        ...state,
        [action.key]: action.value,
      };
  }
  return state;
};
